import React, { useContext, useEffect } from 'react';
import * as $ from 'jquery';
import DoboxLayerGroup from '../../DoboxLayerGroup';
import Kashika5Layers from '../../DoboxLayerGroup/kashika5Layers';
import { kashika1Options } from './config';
import { kashika2Options } from './kashika2config';
import { kashika3Options } from './kashika3config';
import { kashika4Options } from './kashika4config';
import { kashika5Options } from './kashika5config';
import { kashika6Options } from './kashika6config';
import { kashika7Options } from './kashika7config';
import { kashika8Options } from './kashika8config';
import { spotList } from '../../Spot/register/config'
import { useCookies } from "react-cookie";
import { Context } from '../../../store/reducer';
import VectorGridSlider from '../../VectorGridSlider';

import Vis4PopupReopenButton from "./vis4PopupReopenButton";
import Kashika8CopyUrlButton from "./kashika8CopyUrlButton";

/**
 * ヘッダに表示するアプリの名称を取得する。
 * @param appId
 * @returns {string}
 */
const getAppTitle = (appId) => {
  
  switch (appId) {
    case "1":
      return "災害リスクマップ";
    case "2":
      return "ひろしま2Dマップ";
    case "3":
      return "カメラマップ";
    case "4":
      return "法規制マップ";
    case "5":
      return "不動産・住宅関連データ";
    case "6":
      return "道路マップ";
    case "7":
      return "インフラツーリズムマップ";
    case "8":
      return "防災情報マップ";
  }
}

const getMenuOptions = (appId) => {

  switch (appId) {
    case "1":
      return kashika1Options;
    case "2":
      return kashika2Options;
    case "3":
      return kashika3Options;
    case "4":
      return kashika4Options;
    case "5":
      return kashika5Options;
    case "6":
      return kashika6Options;
    case "7":
      return kashika7Options;
    case "8":
      return kashika8Options;
  }
}


const Component = () => {
    const [cookies,setCookie,removeCookie] = useCookies(["spots", "latitude", "longitude"]);

    const { state, dispatch } = useContext(Context);
    
    const doboxOptions = getMenuOptions(process.env.REACT_APP_KASHIKA);
    
    const title = getAppTitle(process.env.REACT_APP_KASHIKA);
    
    
    const toggleMenu = () => {
        const body = document.body;
        body.classList.toggle('nav-open');
    };
    const toRegisterMode = () => {
        if(cookies.confirm){
            dispatch({type:'TOGGLE_MODE'});
        }else{
            const result = window.confirm("本アプリケーションで利用されたスポット情報を保持することができます。\n情報の保持にあたってはCookie情報を利用いたします。\n上記に同意いただける場合のみスポット情報を保持いたします。");
            if(result){
                setCookie("confirm", true, {maxAge:60*60*24*7})
                dispatch({type:'TOGGLE_MODE'});
            }
        }
    };

    useEffect(() => {
        // 左メニューのアコーディオンのイベントデリゲーション: 親要素にイベントを設定
        $(document).on('click', '.ac-item', function(e) {
            e.preventDefault();
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $(this).next()
                    .stop()
                    .slideUp(300);
            } else {
                $(this).addClass('is-active');
                $(this).next()
                    .stop()
                    .slideDown(300);
            }
        });

        // クリーンアップ関数で重複登録を防止
        // useEffect内のreturn関数は、コンポーネントがアンマウント（削除）される時、または再レンダリング前に実行される。
        // メモリリークの原因となる重複イベントを防ぐことができる。
        return () => {
            $(document).off('click', '.ac-item');
        };
    }, []);

    /**
     * メニューを表示させるかどうかを判定する。
     * @param menuId
     * @returns {boolean}
     */
    const canDisplayMenu = (menuId) => {

        // 環境を限定するメニュー
        const environmentLimitedMenu = {
            "menu_97" : "staging"
        }

        // 環境限定メニューの場合は環境が不一致であれば表示自体を行わない。
        if (environmentLimitedMenu[menuId]
            && environmentLimitedMenu[menuId] !== process.env.REACT_APP_ENVIRONMENT) {
            return false;
        }

        // Ajaxで取得したメニュー表示制御が存在しないか、メニュー表示制御がtrueの場合は表示する
        return (state.menu[menuId] === undefined || state.menu[menuId] === true)
    }

    // 防災情報マップ(KASHIKA=8)では背景を透明にする
    return (
        <header className={`header${process.env.REACT_APP_KASHIKA == 8 ? ' header-transparent' : ''}`}>
            <nav className="gnav">
                <div className="gnav-inner">
                <p className="gnav-sub-ttl is-first">
                    レイヤーを選択
                </p>
                  
                  {/* 左メニューを表示する */}
                  {/* 可視化5専用左メニュー表示 */}
                  {process.env.REACT_APP_KASHIKA == 5 &&
                    doboxOptions.map(category=>(
                      <Kashika5Layers
                        key={category.menuName}
                        menuName={category.menuName}
                        options={category.options}
                        layerOrderList={category.layerOrderList}
                        category={category}
                      />
                    ))
                  }
                  {/* 可視化5以外(いずれ全て独立させるべき) */}
                  {process.env.REACT_APP_KASHIKA != 5 &&
                    doboxOptions.map(category=>(
                        canDisplayMenu(category.menuId)
                          ? 
                          <DoboxLayerGroup
                            key={category.menuName}
                            menuName={category.menuName}
                            options={category.options}
                            category={category}
                            activeLabel={""}
                          />
                          :
                          <></>
                      
                    ))
                  }

                {/* 可視化4法規制マップのポップアップの再表示ボタン */}
                {process.env.REACT_APP_KASHIKA == 4 &&
                  <Vis4PopupReopenButton />
                }

                {/* 可視化8防災情報マップのURL共有ボタン */}
                {process.env.REACT_APP_KASHIKA == 8 &&
                  <Kashika8CopyUrlButton />
                }
                
                {process.env.REACT_APP_KASHIKA == 1 &&
                    <>
                        <p className="gnav-sub-ttl">スポット</p>
                        <div className="gnav-list-ac">
                            <p className="f-check">
                                <input type="checkbox" id="cbmy-00" checked={state.regist}
                                    onChange={()=>dispatch({
                                        type: 'TOGGLE_MARKER_VISIBLE',
                                        category: "regist"
                                    })}/>
                                <label htmlFor="cbmy-00">登録したスポット</label>
                            </p>
                            <div className="ac-item"></div>
                            <ul id="ac-item-ul">
                                {spotList.map(spot => (
                                    <li key={spot.type}>
                                        <p className="f-check">
                                            <input type="checkbox" id={spot.name} checked={state[spot.type]}
                                                onChange={()=>{
                                                    dispatch({
                                                        type: 'TOGGLE_MARKER_VISIBLE',
                                                        category: spot.type
                                                    })
                                                }}
                                            /><label htmlFor={spot.name}><span className="icon-marker"><img src={spot.src} alt={spot.name}/></span><span className="icon-name">{spot.name}</span></label></p>
                                    </li>
                                ))}
                            </ul>
                            <div className="gnav-spot-btn">
                                <a href="#" className="c-btn c-btn-spot" onClick={()=>toRegisterMode()}>スポットを登録</a>
                            </div>
                            {/* <input type="button" value="登録スポットを削除する" onClick={()=>removeCookie("spots")}/> */}
                        </div>
                    </>
                }
                </div>
            </nav>
            <div className="gnav-toggle" id="js-hamburger" onClick={() => toggleMenu()}>
                <span className="gnav-toggle-line gnav-toggle-line--1"></span>
                <span className="gnav-toggle-line gnav-toggle-line--2"></span>
                <span className="gnav-toggle-line gnav-toggle-line--3"></span>
                <span className="gnav-txt">設定</span>
            </div>
            {/* 防災情報マップ(KASHIKA=8)ではタイトル・印刷・ホームを非表示 */}
            {process.env.REACT_APP_KASHIKA != 8 &&
            <>
            <div className="header-title">
                <h1>{title}</h1>
            </div>
            <div className="h-print">
                <div className="h-print-inner">
                    <a href='#' onClick={() => window.print()}>
                        <span className="h-print-icon"></span>
                        <span className="h-home-txt">印刷</span>
                    </a>
                </div>
            </div>
            <div className="h-home">
                <div className="h-home-inner">
                    <a href={process.env.REACT_APP_HOME_URL}><span className="h-home-icon"></span><span className="h-home-txt">ホーム</span></a>
                </div>
            </div>
            </>
            }
            <div className="black-bg" id="js-black-bg"></div>

            <VectorGridSlider />
        </header>
    )
}

export default Component;
